<template>
  <div class="box">
    <div class="container clearfix">
      <div class="fl goodsClassBox">
        <div class="classTitle">
          <div class="fl txt"></div>
          <div class="fr title-icon"></div>
        </div>
        <ul class="classListBox" v-show="navState">
          <li style="line-height:180%">&nbsp;&nbsp;&nbsp;&nbsp;戏游互动科技（北京）有限公司成立于2015年7月，主要从事互联网中华文化项目。我们拥有优秀的市场运营团队，一直致力于线上文化产业的宣传和推广，希望我们的活动能够产生更多的商业利润并为全球用户带来更深刻的文化知识，影响每一个年龄层对于艺术的理解，更好的传播和传承中华文化。</li>
        </ul>

      </div>
      <div class="fr navBox">
        <span>首页</span>
        <!-- <span>直播</span> -->
        <span @click="goNews">行业资讯</span>
        <span @click="goAbout">联系我们</span>
        <!-- <span @click="goHelp">帮助中心</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/goods";
import storage from "@/common/storage";
import { mapGetters } from "vuex";
export default {
  props: ["type"],
  data() {
    return {
      oneLevel: [],
      twoLevel: [],
      listCenter: false,
      paItem: {},
      mockData: {},
    };
  },
  methods: {
    goNews(){
      this.$router.push("/news")
    },
    goAbout(){
      this.$router.push("/about")
    },
    goHelp(){
      this.$router.push("/help")
    },
    async getMockData() {
      let res = (await import("../home/mock/home.js")).default;
      this.mockData = res.data;
      this._getOneLevel(res);
    },
    //  获取一级分类
    _getOneLevel(res) {
      this.oneLevel = res.data.firstClass;
      // api.getOneLevel()
      // .then((res) => {
      //   if(res.status === 'ok'){
      //     this.oneLevel = res.data
      //   }else if(res.status === 'error'){
      //     console.log(res.data)
      //   }
      // })
    },
    // 获取二级分类
    _getTwoLevel(item) {
      this.paItem = item;
      this.twoLevel = this.mockData.secondClass[item.class_id-1];
      // api.getTwoLevel({
      //   class_uuid: item.class_uuid
      // }).then((res) => {
      //   if(res.status === 'ok'){
      //     this.twoLevel = res.data
      //   }else if(res.status === 'error'){
      //     console.log(res.data)
      //   }
      // })
    },
    levelFun(type, item) {
      if (type == 1) {
        if (item) {
          this._getTwoLevel(item);
        }
        this.listCenter = true;
      } else {
        this.listCenter = false;
      }
    },
    // 分类显示隐藏事件
    navToggle() {
      if (this.type != 1) {
        this.setGoodsNav(this.goodsNavState);
      }
    },

    // 一级分类跳转事件
    oneLevelGo(item) {
      this.setGoodsNav(true);
      this.listCenter = false;
      this.$emit("one-level", item);
    },

    // 二级分类跳转事件
    twoLevelGo(paItem, item) {
      this.setGoodsNav(true);
      this.listCenter = false;
      this.$emit("two-level", paItem, item);
    },
  },
  computed: {
    ...mapGetters(["goodsNavState"]),
    navState() {
      return this.$route.path != "/mall/home" ? this.goodsNavState : true;
    },
  },
  created() {
    this.getMockData();
    // this._getOneLevel()
  },
};
</script>

<style scoped>
.box {
  position: relative;
  width: 100%;
  background: #fff;
  border-bottom: 2px solid #3f8fdf;
}
.goodsClassBox {
  width: 195px;
  position: relative;
}
.classTitle {
  background-color: #4da0f3;
  height: 40px;
  line-height: 40px;
}
.classTitle .txt {
  font-weight: bold;
  font-size: 18px;
  color: #fff;
  margin-left: 20px;
}
.title-icon {
  float: right;
  width: 20px;
  height: 20px;
  background: url(../../../assets/icon/fenlei2.png) no-repeat center;
  background-size: 20px 20px;
  margin: 10px 10px;
  cursor: pointer;
}
.classListBox {
  position: absolute;
  top: 40px;
  left: 0;
  width: 195px;
  height: 400px;
  background-color: #3f8fdf;
  padding-top: 10px;
  color: #fff;
  z-index: 100;
}
.classListBox li {
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  cursor: pointer;
}
.classListBox li:hover {
  /* background-color: #ff9e31; */
}
.list-center {
  position: absolute;
  top: 43px;
  left: 195px;
  width: 705px;
  height: 397px;
  background-color: #fff;
  z-index: 99;
  padding: 10px 15px;
}
.list {
  margin: 10px 18px;
  cursor: pointer;
}
.list:hover {
  color: red;
}
.listTitle {
  text-align: center;
  font-size: 14px;
  margin-top: 5px;
}
.navBox {
  width: 1005px;
  height: 40px;
  line-height: 40px;
  padding: 0 30px;
  font-size: 16px;
}
.navBox span {
  cursor: pointer;
  padding: 0 30px;
}
.navBox span:hover {
  color: #3f8fdf;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/private/nav.vue